import React, { useState } from 'react';
import { VetRecords, AdminSchedule } from '../admin';
import { api } from '../../src/services/api-new';

interface DoctorDashboardProps {
    onBack?: () => void;
}

const DoctorDashboard: React.FC<DoctorDashboardProps> = ({ onBack }) => {
    const [activeTab, setActiveTab] = useState<'schedule' | 'records'>('schedule');
    const [selectedPatientId, setSelectedPatientId] = useState<string | undefined>(undefined);
    const [activeAppointmentId, setActiveAppointmentId] = useState<number | undefined>(undefined);

    const handleStartConsultation = async (patientId: string, appointmentId: number) => {
        try {
            await api.appointments.updateStatus(appointmentId, 'ANAMNESA');
            setSelectedPatientId(patientId);
            setActiveAppointmentId(appointmentId);
            setActiveTab('records');
        } catch (error) {
            console.error("Failed to start consultation:", error);
            alert("Failed to start consultation");
        }
    };

    return (
        <div className="h-full flex flex-col space-y-6">
            <div className="flex justify-between items-center bg-white dark:bg-surface-dark p-6 rounded-[2rem] shadow-sm border border-gray-100 dark:border-gray-800">
                <div>
                    <h2 className="text-2xl font-black text-primary-dark dark:text-white tracking-tight">Doctor Control Center</h2>
                    <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mt-1">Clinical Operations & Records</p>
                </div>
                <div className="flex bg-slate-100 dark:bg-gray-800 p-1.5 rounded-2xl shadow-inner">
                    <button
                        onClick={() => setActiveTab('schedule')}
                        className={`px-6 py-2 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all ${activeTab === 'schedule' ? 'bg-white dark:bg-surface-dark text-primary shadow-sm ring-1 ring-black/5' : 'text-gray-400 hover:text-gray-600'
                            }`}
                    >
                        Daily Schedule
                    </button>
                    <button
                        onClick={() => setActiveTab('records')}
                        className={`px-6 py-2 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all ${activeTab === 'records' ? 'bg-white dark:bg-surface-dark text-primary shadow-sm ring-1 ring-black/5' : 'text-gray-400 hover:text-gray-600'
                            }`}
                    >
                        Medical Records
                    </button>
                </div>
            </div>

            <div className="flex-1 overflow-hidden">
                {activeTab === 'schedule' ? (
                    <AdminSchedule onStartConsultation={handleStartConsultation} />
                ) : (
                    <VetRecords initialPatientId={selectedPatientId} appointmentId={activeAppointmentId} />
                )}
            </div>
        </div>
    );
};

export default DoctorDashboard;
